import { type ChildEvent } from '../types';
import { isNotDeleted } from './isNotDeleted';

export function convertChildEvents(childEvents: ChildEvent[] | undefined): ChildEvent[] | undefined {
    return (
        childEvents?.filter(isNotDeleted).map((event) => ({
            ...event,
            resources: event.resources?.filter(isNotDeleted),
            dateFrom: new Date(event.dateFrom),
            dateTo: new Date(event.dateTo),
        })) ?? undefined
    );
}
